import api from './api';

export const authService = {
  // User Authentication
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  verifyOtp: (data) => api.post('/auth/verify-otp', data),
  resendOtp: (userId) => api.post(`/auth/resend-otp/${userId}`),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  changePassword: (data) => api.post('/auth/change-password', data),
  getMe: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),

  // Sponsor Authentication
  sponsorLogin: (data) => api.post('/sponsor/login', data),
  sponsorRegister: (data) => api.post('/sponsor/register', data),

  // Admin Panel Authentication
  adminPanelLogin: (data) => api.post('/admin-panel/login', data),
  adminPanelCreatePassword: (data) => api.post('/admin-panel/create-password', data),
  adminPanelForgotPassword: (data) => api.post('/admin-panel/forgot-password', data),
  adminPanelVerifyOtp: (data) => api.post('/admin-panel/verify-otp', data),
  adminPanelChangePassword: (data) => api.post('/admin-panel/change-password', data),
  adminPanelResetPassword: (data) => api.post('/admin-panel/reset-password', data),
  adminPanelLogout: () => api.post('/admin-panel/logout'),

  // Validation
  checkEmail: (email) => api.post('/users/check-email', { email }),
  checkUsername: (username) => api.post('/users/check-username', { username }),
  checkPhoneNumber: (phoneNumber) => api.post('/users/check-phone', { phoneNumber }),
};

export default authService;
